module.exports = __webpack_public_path__ + "img/level2addon_running_gun.dabd55d9.png";